module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-500.0fef9913.ttf";